import { FETCH_HISTORY_DATA, HIDE_LOADER, SHOW_LOADER } from "../types";

const initialState = {
  loading: true,
  historyData: [],
};

export const consumerHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, loading: true };
    case HIDE_LOADER:
      return { ...state, loading: false };
    case FETCH_HISTORY_DATA:
      return { ...state, historyData: action.payload };
    default:
      return state;
  }
};
